import script from "./SearchtPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchtPage.vue?vue&type=script&setup=true&lang=ts"

import "./SearchtPage.vue?vue&type=style&index=0&id=c291736a&lang=scss"

const __exports__ = script;

export default __exports__